import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/#services", label: "Services" },
  { to: "/#portfolio", label: "Portfolio" },
  { to: "/#about", label: "About" },
  { to: "/blog", label: "Journal" },
  { to: "/#contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (to) => {
    setOpen(false);
    if (to.includes("#")) {
      const id = to.split("#")[1];
      if (location.pathname === "/" || to.startsWith("/#")) {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-onyx-900/85 backdrop-blur-xl border-b border-gold/15" : "bg-transparent"
      }`}
      data-testid="site-navbar"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-10 md:py-5">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-home-link">
          <Logo size={84} withText />
        </Link>

        <nav className="hidden md:flex items-center gap-9" data-testid="nav-desktop">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              onClick={() => handleNav(l.to)}
              className="font-cinzel text-[11px] tracking-[0.28em] uppercase text-ivory/75 hover:text-gold transition-colors duration-300"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/admin"
            className="font-cinzel text-[10px] tracking-[0.3em] uppercase text-gold/70 hover:text-gold border border-gold/30 hover:border-gold px-4 py-2 transition-all"
            data-testid="nav-admin-link"
          >
            Admin
          </Link>
        </nav>

        <button
          className="md:hidden text-gold p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-gold/15 bg-onyx-900/95 backdrop-blur-xl" data-testid="nav-mobile">
          <div className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                onClick={() => handleNav(l.to)}
                className="font-cinzel text-xs tracking-[0.3em] uppercase text-ivory/85 hover:text-gold"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/admin"
              className="font-cinzel text-xs tracking-[0.3em] uppercase text-gold border border-gold/40 px-4 py-3 text-center"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-admin"
            >
              Admin Login
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
